import { render, staticRenderFns } from "./alterPassword.vue?vue&type=template&id=4688900e&scoped=true&"
import script from "./alterPassword.vue?vue&type=script&lang=js&"
export * from "./alterPassword.vue?vue&type=script&lang=js&"
import style0 from "./alterPassword.vue?vue&type=style&index=0&id=4688900e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4688900e",
  null
  
)

export default component.exports